/**
 * Convertes ISO date string to short local date format.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'localDate' })
export class LocalDatePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) return '';

		try {
			const date = new Date(value);
			if (isNaN(date.getTime())) return '';

			return date.toLocaleTimeString(undefined, {
				hour: 'numeric',
				hour12: false,
				minute: 'numeric',
				year: 'numeric',
				month: 'short',
				day: '2-digit',
			});
		} catch (e) {
			return '';
		}
	}
}
